import { render } from "./HomeAbout.vue?vue&type=template&id=7512ed8d&scoped=true"
import script from "./HomeAbout.vue?vue&type=script&lang=js"
export * from "./HomeAbout.vue?vue&type=script&lang=js"

import "./HomeAbout.vue?vue&type=style&index=0&id=7512ed8d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7512ed8d"]])

export default __exports__